function callAll(funcs) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        funcs.forEach(function (func) { return func === null || func === void 0 ? void 0 : func.apply(void 0, args); });
    };
}
function addFlexFix(element) {
    var _a = element.getBoundingClientRect(), width = _a.width, height = _a.height;
    element.style.width = "".concat(width, "px");
    element.style.height = "".concat(height, "px");
    element.style.left = "".concat(element.offsetLeft, "px");
    element.style.top = "".concat(element.offsetTop, "px");
}
function removeFlexAndFlexScrollbarFix(element) {
    element.style.width = '';
    element.style.height = '';
    element.style.left = '';
    element.style.top = '';
}
function addFlexScrollbarXFix(element) {
    var _a = element.getBoundingClientRect(), width = _a.width, height = _a.height;
    element.style.width = "".concat(width, "px");
    element.style.height = "".concat(height, "px");
    element.style.top = "".concat(element.offsetTop, "px");
    var scrollerElement = element.parentElement;
    if (!scrollerElement || element !== scrollerElement.lastElementChild) {
        element.style.left = "".concat(element.offsetLeft, "px");
        return;
    }
    var clientWidth = scrollerElement.clientWidth;
    var scrollWidth = scrollerElement.scrollWidth;
    var scrollLeft = scrollerElement.scrollLeft;
    var computedStyle = getComputedStyle(scrollerElement);
    var itemOffsetWidth = parseInt(computedStyle.gap) + width;
    if (clientWidth === scrollWidth || Math.ceil(scrollLeft + clientWidth + itemOffsetWidth) < scrollWidth) {
        element.style.left = "".concat(element.offsetLeft, "px");
        return;
    }
    element.style.left = "".concat(element.offsetLeft - itemOffsetWidth, "px");
}
function addFlexScrollbarYFix(element) {
    var _a = element.getBoundingClientRect(), width = _a.width, height = _a.height;
    element.style.width = "".concat(width, "px");
    element.style.height = "".concat(height, "px");
    element.style.left = "".concat(element.offsetLeft, "px");
    var scrollerElement = element.parentElement;
    if (!scrollerElement || element !== scrollerElement.lastElementChild) {
        element.style.top = "".concat(element.offsetTop, "px");
        return;
    }
    var clientHeight = scrollerElement.clientHeight;
    var scrollHeight = scrollerElement.scrollHeight;
    var scrollTop = scrollerElement.scrollTop;
    var computedStyle = getComputedStyle(scrollerElement);
    var itemOffsetHeight = parseInt(computedStyle.gap) + height;
    if (clientHeight === scrollHeight || Math.ceil(scrollTop + clientHeight + itemOffsetHeight) < scrollHeight) {
        element.style.top = "".concat(element.offsetTop, "px");
        return;
    }
    element.style.top = "".concat(element.offsetTop - itemOffsetHeight, "px");
}

export { addFlexFix, addFlexScrollbarXFix, addFlexScrollbarYFix, callAll, removeFlexAndFlexScrollbarFix };
